import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface FooterProps {
  full?: boolean;
}

function Footer({ full }: FooterProps) {
  const { t } = useTranslation();
  return (
    <footer className="armf-footer mt-auto">
      <div className="armf-footer__inner">
        <span className="armf-footer__copy">
          {t('footer.copyright', { year: new Date().getFullYear() })}
        </span>
        <div className="armf-footer__links">
          <Link className="armf-footer__link" to="/terms-of-service">
            {t('footer.terms')}
          </Link>
          <Link className="armf-footer__link" to="/privacy-policy">
            {t('footer.privacy')}
          </Link>
          <Link className="armf-footer__link" to="/cookies-policy">
            {t('footer.cookies')}
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
